import * as React from 'react';
import { Box, Dialog, DialogContent } from '@mui/material';
import { SharedImages } from '../../assets/images';

export type LoadingProps = {
  isLoading: boolean;
};

const Loading: React.FC<LoadingProps> = ({ isLoading }) => {
  return (
    <Dialog
      data-testid="Loader"
      open={isLoading}
      slotProps={{
        paper: {
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
      }}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <DialogContent
        sx={{
          width: '500px',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          alt="Loading"
          src={SharedImages.loading.default}
          height={50}
          width={50}
          className="loading-icon"
          sx={{ animation: 'spin 2s linear infinite' }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default Loading;
